import { AlertCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

interface OverdueBadgeProps {
  count: number;
}

export function OverdueBadge({ count }: OverdueBadgeProps) {
  const { t } = useTranslation();

  if (count <= 0) return null;

  return (
    <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-sm font-medium bg-destructive/10 text-destructive border border-destructive/20">
      <AlertCircle className="h-4 w-4" />
      {count} {t("dashboard.overdue").toLowerCase()}
    </span>
  );
}
